import React from 'react';
import View from './View';
import Image from './Image';
import Text from './Text';
import MainLogo from '../../../../public/images/GHmain.png';
import { Theme } from '../../../theme';

const Footer = () => (
  <View
    fixed
    position="absolute"
    bottom={0}
    left={20}
    right={20}
    flexDirection="row"
    alignItems="flex-start"
    justifyContent="flex-end"
    backgroundColor="white"
    pt="5pt"
    pb="15pt"
  >
    <View flexDirection="row" alignItems="flex-end">
      <Image height={16} backgroundColor="white" src={MainLogo} />
      <View ml={1}>
        <Text fontSize="10pt" color={Theme.colors.greyLight}>
          - Grant Holster, LLC &#174;
        </Text>
      </View>
    </View>
  </View>
);

export default Footer;
